module.exports = __webpack_public_path__ + "img/transport.156f9b87.png";